import { render, staticRenderFns } from "./MCQStitcher.vue?vue&type=template&id=582fa339&"
import script from "./MCQStitcher.vue?vue&type=script&lang=js&"
export * from "./MCQStitcher.vue?vue&type=script&lang=js&"
import style0 from "./MCQStitcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports